module.exports = __webpack_public_path__ + "static/23-dce7750f6695beee91c5afc77a7bcef7.png";